import React, { useRef, useEffect, useState } from 'react';

import { Button, Box, Grid, Typography } from "@material-ui/core"

import VideoContainer from "../Components/VideoContainer"
import LogoAnimation from "../Components/LogoAnimation"

import Controls from "./Controls"

export default ({
    name, description
}) => {
    const [dimensions, setDimensions] = useState({
        width: 1080,
        height: 1920
    });

    const handleSetDimensions = (size) => {
        const sizeParts = size.split("x");
        setDimensions({
            width: sizeParts[0],
            height: sizeParts[1]
        })
    }

    const controlProps = {
        setDimensions: handleSetDimensions,
        name,
        description
    }

    return (
        <React.Fragment>
            <Controls {...controlProps} />

            <VideoContainer id="canvas-recording" {...dimensions}>
                <LogoAnimation size={2} {...dimensions} />
            </VideoContainer>
        </React.Fragment>
    )
}